const styles = (theme) => ({
  dialog: {
    width: 470,
    backgroundColor: theme.ModalBGColor,
    overflowY: "visible",
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 16px",
    borderBottom: `1px solid ${theme.scrollThumbColor}`,
  },
  closeButton: {
    padding: 2,
    color: theme.iconColor,
  },
  dialogTitleText: {
    fontSize: theme.headerTextFontSize,
    fontWeight: "600",
    lineHeight: "20px",
    color: theme.palette.primary.main,
    padding: 0,
    display: "flex",
    alignItems: "center",
  },
  dialogContent: {
    position: "relative",
    padding: "0px",
  },
  loader: {
    position: "absolute",
    height: "100%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.loaderBgColorTranslucent,
    zIndex: 999,
  },
  backButton: {
    marginRight: 5,
    padding: 2,
    color: theme.palette.primary.main,
  },
});
export default styles;
